/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { EnumDataModel } from '@midas/shared/common';
import { TranslocoModule } from '@ngneat/transloco';
import { Observable, of } from 'rxjs';
import { IQuerySelect, PagedResult } from '../ui-query-select';

@Component({
  selector: 'midas-ui-enumtype-query-select',
  templateUrl: './ui-enumtype-query-select.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatChipsModule,
    MatAutocompleteModule,
    MatIconModule,
    MatButtonModule,
    TranslocoModule,
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => UiEnumTypeQuerySelectComponent),
      multi: true,
    },
  ],
})
export class UiEnumTypeQuerySelectComponent extends IQuerySelect<EnumDataModel> {
  @Input() label = '';
  @Input() data!: EnumDataModel[];

  constructor(protected _change: ChangeDetectorRef) {
    super(_change);
  }

  getItemsBySearchString(searchString?: string | null): Observable<PagedResult<EnumDataModel>> {
    return of({
      count: this.data.length,
      items: this.data.filter((item) => {
        return item.name.toLowerCase().includes((searchString ?? '').toLowerCase());
      }),
    });
  }

  getItemsByIds(ids: number[]): Observable<EnumDataModel[]> {
    return of(this.data.filter((w) => ids.includes(w.id)));
  }
}
